<div>
  <div class="text-right mb-2">
    <div *ngIf="isDisabled" class="button text-uppercase btn-green" (click)="isDisabled=false">{{"EDIT_ORDER" |translate}}</div>
    <span *ngIf="!isDisabled">
      <div class="button text-uppercase btn-grey mr-3" (click)="isDisabled=true">{{"CANCEL" |translate}}</div>
      <div class="button text-uppercase btn-green" (click)="saveOrdering()">{{"SAVE" |translate}}</div>
    </span>
    <div class="btn-info button ml-3 text-uppercase" (click)="openModalCreate()">{{"CREATE" |translate}}</div>
  </div>
  <div cdkDropList #pendingList="cdkDropList" [cdkDropListData]="projectsIds" (cdkDropListDropped)="drop($event)">
    <div class="row-drag flex-space-between" *ngFor="let id of projectsIds" cdkDrag [cdkDragDisabled]="isDisabled">
      <span class="row-content">
        <img class="mr-3 cursor-drag d-inline-b v-middle"  *ngIf="!isDisabled" src="./assets/img/drag.svg" width="16">
        <div class="d-inline-b v-middle w-80">
          <div *ngFor="let item of getProjectById(id); let last = last" [ngClass]="{'mb-3': !last}">
            <img [src]="getFlag(item.lang)" width="20">
            <div class="mb-1 ml-2 d-inline-b"> {{item.title}}</div>
            <div>{{item.description}}</div>
          </div>
        </div>
        <span class="d-inline-b w-20 text-right">
          <img class="bg-white p-1" [src]="getImage(getProjectById(id)[0])" height="30">
        </span>
      </span>
      <span>
        <img class="ml-3 cursor" src="./assets/img/pencil.svg" width="20" (click)="showModalEdit(id)">
        <img class="ml-3 mr-3 cursor" src="./assets/img/picture.svg" width="20" (click)="showModalImage(id)">
        <img class="cursor" (click)="showModalDelete(id)" src="./assets/img/delete.svg" width="20">
      </span>
    </div>
  </div>

  <!-- <div class="row-stripe flex-space-between" *ngFor="let id of projectsIds">
    <span class="row-content v-top">
      <div *ngFor="let item of getProjectById(id); let last = last" [ngClass]="{'mb-3': !last}">
        <img [src]="getFlag(item.lang)" width="20">
        <div class="mb-1 ml-2 d-inline-b"> {{item.title}}</div>
        <div>{{item.description}}</div>
     
      </div>
    </span>
    <span class="v-top">
      <img class="ml-3 cursor" src="./assets/img/pencil.svg" width="20" (click)="showModalEdit(id)">
      <img class="ml-3 mr-3 cursor" src="./assets/img/picture.svg" width="20" (click)="showModalImage(id)">
      <img class="cursor" (click)="showModalDelete(id)" src="./assets/img/delete.svg" width="20">
    </span>
  </div> -->
</div>

<div class="modal modal-project" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="modal-title flex-space-between">
          {{"EDIT_PROJECT" | translate}}
          <img class="cursor" src="assets/img/close.svg" width="10" data-dismiss="modal">
        </div>
        <div class="modal-text pt-4">
          <div *ngFor="let item of getProjectById(selectedId)" class="mb-4">
            <div class="flex-space-between mb-2">
              <img [src]="getFlag(item.lang)" width="30" class="mr-2">
              <input type="text" [(ngModel)]="item.title" />
            </div>
            <textarea [(ngModel)]="item.description" rows="6"></textarea>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="button btn-grey text-uppercase" data-dismiss="modal">{{"CANCEL" | translate}}</div>
        <div class="button btn-green text-uppercase" data-dismiss="modal" (click)="save()">OK</div>
      </div>
    </div>
  </div>
</div>

<div class="modal delete-project" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="modal-title red flex-space-between">
          {{"DELETE_PROJECT" | translate}}
          <img class="cursor" src="assets/img/close.svg" width="10" data-dismiss="modal">
        </div>
        <div class="modal-text pt-4">
          {{"SURE_TO_DELETE" | translate}}
          <span *ngFor="let item of getProjectById(selectedId)">
            <span class="bold" *ngIf="item.lang=='it-IT'">{{item.description}}</span>
          </span>?
        </div>
      </div>
      <div class="modal-footer">
        <div class="button btn-grey text-uppercase" data-dismiss="modal">{{"CANCEL" | translate}}</div>
        <div class="button btn-green text-uppercase" data-dismiss="modal" (click)="deleteProject()">OK</div>
      </div>
    </div>
  </div>
</div>

<div class="modal image-project" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="modal-title flex-space-between">
          {{"EDIT_IMAGE" | translate}}
          <img class="cursor" src="assets/img/close.svg" width="10" data-dismiss="modal">
        </div>
        <div class="modal-text pt-4 flex-around">
          <span *ngFor="let item of getProjectById(selectedId); let first=first" [ngClass]="{'d-none': !first}">
            <img [src]="getImage(item)" class="img-modal">
          </span>
          <div class="pl-3 pr-3">
            <div class="bold text-uppercase mb-2">{{"EDIT_IMAGE" | translate}}</div>
            <input type="file" class="border-grey cursor" id="fileProject">

            <!-- <div class="bold text-uppercase button btn-red mt-3 cursor" (click)="removeImage(selectedId)">{{"REMOVE_IMAGE" | translate}}</div> -->
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="button btn-grey text-uppercase" data-dismiss="modal">{{"CANCEL" | translate}}</div>
        <div class="button btn-green text-uppercase" data-dismiss="modal" (click)="saveImage(selectedId)">{{"SAVE" | translate}}</div>
      </div>
    </div>
  </div>
</div>